__turbopack_context__.v({
  "ddLabel": "ContactSupport-module-scss-module__y2G9kq__ddLabel",
  "ddRoot": "ContactSupport-module-scss-module__y2G9kq__ddRoot",
  "option": "ContactSupport-module-scss-module__y2G9kq__option",
  "root": "ContactSupport-module-scss-module__y2G9kq__root",
  "selectedOption": "ContactSupport-module-scss-module__y2G9kq__selectedOption",
});
